/**
 * Created by zoechodosh on 3/22/17.
 */
import fetch from 'isomorphic-fetch';

import ApiService from '@zola-helpers/client/dist/es/http/api';
import { toastsActions } from '@zola-helpers/client';

import {
  updateEntityRequest,
  receiveEntityResponse,
  receiveUpdatedEntityResponse,
  getEntitiesRequest,
  getEntitiesResponse,
  editEntityRequest,
} from '../EntityActions';

const ENTITY_LIST_NAME = 'photos';
const SECONDARY_ENTITY_LIST_NAME = 'videos';

// TODO: MOVE THIS AND USE FOR ALL REQUESTS!!!!
function handleErrors(response) {
  if (!response.ok) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return response;
}

export function getPhotos() {
  return dispatch => {
    dispatch(getEntitiesRequest());
    return fetch('/web-api/v1/cms/page/photo', {
      credentials: 'same-origin',
    })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => {
        const photos = json[ENTITY_LIST_NAME];
        const videos = json[SECONDARY_ENTITY_LIST_NAME];
        dispatch(getEntitiesResponse([...photos, ...videos]));
      });
  };
}

export const editPhoto = photo => dispatch => {
  dispatch(editEntityRequest(photo));
};

export function addPhoto(createPhotoRequest) {
  return dispatch => {
    dispatch(updateEntityRequest());
    return fetch('/web-api/v1/cms/page/photo/create', {
      credentials: 'same-origin',
      headers: {
        'Content-type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(createPhotoRequest),
    })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => {
        dispatch(toastsActions.positive({ headline: 'Photo Added' }));
        return json;
      })
      .then(json => dispatch(receiveEntityResponse(json)));
  };
}

export function updatePhoto(updatedPhotoRequest) {
  return dispatch => {
    dispatch(updateEntityRequest());
    return fetch('/web-api/v1/cms/page/photo/update', {
      credentials: 'same-origin',
      headers: {
        'Content-type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(updatedPhotoRequest),
    })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => {
        dispatch(toastsActions.positive({ headline: 'Photo Updated' }));
        return json;
      })
      .then(json => dispatch(receiveUpdatedEntityResponse(json)));
  };
}

export function updateExistingPhoto(newPhoto, existingPhoto, caption) {
  return dispatch => {
    const reqBody = {
      id: existingPhoto.id,
      image_id: newPhoto.uuid,
      caption,
    };
    return ApiService.put('/web-api/v3/cms/photo', reqBody)
      .then(() => {
        dispatch(getPhotos());
      })
      .catch(() => {
        dispatch(toastsActions.negative({ headline: 'Error updating photo' }));
      });
  };
}

export function addMultiplePhotos(payload, photoLimit) {
  return dispatch => {
    const photosCount = payload.create_photo_requests.length;
    return ApiService.post('/web-api/v3/cms/photo/addmulti', payload)
      .then(data => {
        dispatch(getPhotos());
        dispatch(
          toastsActions.positive({
            headline: `${photosCount} ${photosCount === 1 ? 'Photo' : 'Photos'} Added`,
          })
        );
        return data;
      })
      .catch(error => {
        if (error && error.message.includes('limit')) {
          dispatch(
            toastsActions.negative({ headline: `Upload exceeded ${photoLimit} photo limit` })
          );
          return;
        }
        dispatch(toastsActions.negative({ headline: 'Error uploading photos' }));
      });
  };
}

export function updateMultiplePhotos(payload) {
  return dispatch => {
    return ApiService.post('/web-api/v3/cms/photo/updatemulti', payload)
      .then(() => {
        dispatch(getPhotos());
      })
      .catch(() => {
        dispatch(toastsActions.negative({ headline: 'Error updating photos' }));
      });
  };
}
